/* eslint no-else-return: 0 */

/* DEPRECATED - DO NOT REUSE */
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { OverviewLink } from 'components';
import en from '../../../../international/translations/en';

export default class StatusMessage extends Component {

  static propTypes = {
    onClickHandler: PropTypes.func,
    subscription: PropTypes.object,
    theme: PropTypes.string.isRequired,
    brand: PropTypes.string.isRequired,
    overview: PropTypes.object,
    daysUntilCancelDate: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.copy = en.account.overview.statusCard.delinquent;
  }

  trackClick = () => {
    window.analytics.track(
      `Clicked ${this.copy.link_text}`,
      { location: 'account-overview',
        user: {
          type: this.props.subscription
        }
      }
    );
  }

  render() {
    const { brand, theme, daysUntilCancelDate } = this.props;
    const copy = this.copy;
    const buttonTheme = (theme === 'delinquent') ? 'warning' : 'primary';
    const brandName = { 'sl': 'Surfline', 'bw': 'Buoyweather', 'fs': 'FishTrack'};

    return (
      <div className={`status${theme ? '--' + theme : ''}`}>
        <div className="status__message">
          <span className="status__message__title">{copy.title}</span>
          <p>{copy.message(daysUntilCancelDate, brandName[brand])}</p>
        </div>
        <div className="status__link">
          <OverviewLink onClickHandler={this.trackClick} theme={buttonTheme} href={'/account/subscription'}>
            {copy.link_text}
          </OverviewLink>
        </div>
      </div>
    );
  }
}
